import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationService } from '../core/_infrastructure/classes/services/configuration.service';
import { CookiesService } from '../core/_infrastructure/classes/services/cookies.service';
import { COOKIE_CLAVE_NAME, ERROR_CLAVE_KEYS } from '../core/_infrastructure/types/aclave';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
})
export class ErrorComponent {
    title = 'Autenticación fallida';
    errorDescription =
        'Certificado no encontrado en la petición. Si dispone de un certificado digital válido, cierre completamente el navegador e inténtelo de nuevo';

    private activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const errorId: string = '' + params.get('errorId');
        switch (errorId) {
            case ERROR_CLAVE_KEYS.LOGINKO:
                this.errorDescription = 'Se ha producido un error durante el proceso de login';
                break;
            case ERROR_CLAVE_KEYS.NOT_AUTHORIZED:
                this.errorDescription = 'Usuario no autorizado';
                console.error('Se ha producido un error al obtener los datos de la identidad o al autorizar al usuario contra Cl@ve');
                break;
            case ERROR_CLAVE_KEYS.LOGOUT:
                this.errorDescription = 'Se ha producido un error al consultar la respuesta del Logout en el cierre de sesión';
                break;
            case ERROR_CLAVE_KEYS.UNSUCESSFULL_LOGIN:
                this.errorDescription = 'Se ha producido un error al obtener la respuesta del login de Cl@ve';
                break;
            case ERROR_CLAVE_KEYS.UNSUCESSFULL_LOGOUT:
                this.errorDescription = 'Se ha producido un error al cerrar la sesión de Cl@ve';
                break;
            default:
                break;
        }
        this.cookiesService.deleteCookie(COOKIE_CLAVE_NAME);
    });

    constructor(
        protected configurationService: ConfigurationService,
        private activatedRoute: ActivatedRoute,
        private cookiesService: CookiesService,
    ) {}
}
